module.exports = __webpack_public_path__ + "img/handwriting@2x.a5918ab1.png";